import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
export function ItemDetailSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-4"><Skeleton className="aspect-square w-full rounded-2xl shadow-lg" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2"><Skeleton className="w-4 h-4 rounded-sm" /><Skeleton className="w-24 h-4" /></div>;
    t2 = <Skeleton className="w-3/4 h-10 mb-3" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>{t2}<div className="flex flex-wrap gap-2 mt-3"><Skeleton className="w-16 h-7 rounded-full" /><Skeleton className="w-20 h-7 rounded-full" /><Skeleton className="w-14 h-7 rounded-full" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="border-t border-b border-gray-200 py-6"><Skeleton className="w-1/3 h-10" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="space-y-3"><Skeleton className="w-1/4 h-6 mb-2" /><Skeleton className="w-full h-4" /><Skeleton className="w-full h-4" /><Skeleton className="w-full h-4" /><Skeleton className="w-2/3 h-4" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 animate-in fade-in duration-500">{t0}<div className="space-y-6">{t1}{t3}{t4}{t5}<div className="pt-4"><Skeleton className="w-full h-14 rounded-xl" /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}